import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"app"},[_c(VMain,[(!_vm.isAuthorized)?_c('LoginView',{on:{"loginAttempt":_vm.login}}):_c('router-view',{staticClass:"app main"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }